import { Button, Group, Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { useNavigate } from 'react-router-dom';
import { IconChip as IconTrash } from '../../components/icons/CncIcons';
import { api } from '../../api/client';
import { useAuth, canWrite } from '../../store/auth';

// Small red "Delete Order" card shown at the bottom of Order Set-up,
// In Quotation, Supplying Consumables, and In Execution screens.
export default function DeleteOrderSection({ orderId }: { orderId: number }) {
  const navigate = useNavigate();
  const { me } = useAuth();
  const writable = canWrite(me?.role);

  function confirm() {
    modals.openConfirmModal({
      title: 'Delete this order?',
      children: (
        <Text size="sm">
          This permanently removes the order, its parts, and any quotations. This cannot be undone.
        </Text>
      ),
      labels: { confirm: 'Delete order', cancel: 'Cancel' },
      confirmProps: { color: 'red' },
      onConfirm: async () => {
        try {
          await api.delete(`/orders/${orderId}`);
          notifications.show({ message: 'Order deleted.', color: 'gray' });
          navigate('/orders');
        } catch (e: any) {
          notifications.show({ message: e.message ?? 'Delete failed', color: 'red' });
        }
      },
    });
  }

  return (
    <div className="section" style={{ marginTop: 16 }}>
      <div className="section-header danger">Danger Zone</div>
      <div className="section-body">
        <Group justify="space-between" wrap="wrap">
          <Text size="sm" c="dimmed">Remove this order entirely.</Text>
          <Button
            size="xs"
            color="red"
            variant="filled"
            leftSection={<IconTrash size={12} />}
            onClick={confirm}
            disabled={!writable}
          >
            Delete Order
          </Button>
        </Group>
      </div>
    </div>
  );
}
